<header class="topbar">
    <button type="button" class="topbar-iconbtn side-btn" (click)="sidebarService.toogle()"
        [attr.aria-label]="sidebarService.isExpanded() ? 'Ocultar menú' : 'Mostrar menú'"
        [attr.aria-expanded]="sidebarService.isExpanded()" [pTooltip]="sidebarService.isExpanded() ? 'Ocultar menú' : 'Mostrar menú'">
        <i class="pi pi-bars"></i>
    </button>

    <nav class="crumbs" aria-label="Ruta">
        <a [routerLink]="['/home']" class="crumb-home"><i class="pi pi-home"></i>Inicio</a>
        <ng-container *ngFor="let item of breadcrumb; let last = last">
            <i class="pi pi-angle-right"></i>
            <a *ngIf="!last || item.url != ''" [routerLink]="item.url" [class.cur]="last">{{item.label}}</a>
            <span *ngIf="last && item.url == ''" class="cur">{{item.label}}</span>
        </ng-container>
    </nav>

    <div class="gsearch-wrap">
        <label class="gsearch">
            <i class="pi pi-search"></i>
            <input #searchInput type="text" [(ngModel)]="searchTerm" (keyup.enter)="onSearch($event)"
                placeholder="Buscar expediente…" autocomplete="off"
                pTooltip="Permite buscar expediente por referencia, nombre asegurado, telefono, dirección, poblacion, descripción del siniestro" tooltipPosition="bottom" />
        </label>
    </div>
    <p-overlayPanel #overlay [dismissable]="true" [appendTo]="'body'" (onHide)="onOverlayHide()" [style]="{width: '100%', maxWidth: '940px'}">
        <div class="p-2">
            <div class="mb-2">
            <!-- Filtro interno dentro del Overlay -->
            <span class="p-input-icon-left input-field">                
                <input #searchInput type="text" pInputText [(ngModel)]="filterText" (input)="filterResults()" 
                    placeholder="Buscar en mostrados ..." class="search-input" />
            </span>
            <span class="m-3 border-white"><a class="p-button ml-2" (click)="deepSearch()"><i class="pi pi-search-plus mr-2" style="font-size: 12px"></i> Búsqueda en profundidad</a></span>
            <span *ngIf="orderBy=='caseDate'"><a class="p-button ml-2" (click)="orderByCases('caseNumber'); $event.stopPropagation()"><i class="pi pi-sort-alt mr-2" style="font-size: 12px"></i> Ordenar por num expediente</a></span>
            <span *ngIf="orderBy=='caseNumber'"><a class="p-button ml-2" (click)="orderByCases('caseDate'); $event.stopPropagation()"><i class="pi pi-sort-alt-slash mr-2" style="font-size: 12px"></i> Orden original</a></span>
            <span *ngIf="totalResults>25" class="ml-2"><small>Mostrando {{filteredResults.length}} de {{totalResults}} resultados. Concrete más la búsqueda</small></span>
            </div>
                <p-table [value]="filteredResults" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Contrato</th>
                            <th>Expediente</th>
                            <th>Fecha</th>
                            <th>Tramitador</th>
                            <th>Estado</th>
                            <th>Asegurado</th>
                            <th>Dirección</th>
                            <th>Servicios</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                    <tr style="cursor: pointer;">
                        <td>{{ rowData.contract?.code }}</td>
                        <td><a [routerLink]="['/cases/', rowData.id]" (click)="onSelectCase()">{{ rowData.caseNumber }}</a></td>
                        <td>{{rowData.caseDate | date: 'dd/MM/yyyy'}}</td>
                        <td><label [ngClass]="rowData.processor?.absence ? 'text-danger' : ''">{{rowData.processor?.name}}</label></td>
                        <td>
                            <span class="p-tag" [style.backgroundColor]="rowData.caseState?.backgroundColor" [style.foregroundColor]="rowData.caseState?.foregroundColor">
                                <span class="p-tag-label">{{rowData.caseState?.name}}</span>
                            </span>
                        </td>
                        <td>{{rowData.client?.name}}</td>
                        <td>{{rowData.address?.fullAddress}}</td>
                        <td>
                            <div *ngIf="rowData.caseServiceTypes.length > 0">
                                <span *ngFor="let caseServiceType of rowData.caseServiceTypes; let i = index">
                                    <span *ngIf="i>0">, </span>{{caseServiceType.serviceType.name}}
                                </span>
                            </div>
                        </td>
                    </tr>
                    </ng-template>
            </p-table>           
        </div>
    </p-overlayPanel>

    <div class="counters">
        <button type="button" class="counter" *ngIf="totalServicesEnded>0" (click)="goHome('/ServicesEnded')" pTooltip="Citas pendientes de revisar" tooltipPosition="bottom">
            <span class="cl">Citas por revisar</span><span class="cs">Citas</span> <b>{{totalServicesEnded}}</b>
        </button>
        <button type="button" class="counter" *ngIf="totalLogsRecords>0" (click)="goHome('/LogsRecords')" pTooltip="Comunicaciones entrantes de compañía sin revisar" tooltipPosition="bottom">
            <span class="cl">Comunicaciones</span><span class="cs">Comunic.</span> <b>{{totalLogsRecords}}</b>
        </button>
        <button type="button" class="counter" *ngIf="totalcasesIsInitial>0" (click)="goHome('/casesIsInitial')" pTooltip="Expedientes sin citar" tooltipPosition="bottom">
            Sin citar <b>{{totalcasesIsInitial}}</b>
        </button>
    </div>

    <div class="vsep"></div>

    <button type="button" class="topbar-iconbtn plus-btn" (click)="createCase()" pTooltip="Nuevo expediente" tooltipPosition="bottom" aria-label="Nuevo expediente">
        <i class="pi pi-plus"></i>
    </button>
    <button type="button" class="topbar-iconbtn" (click)="showProcessorHome()" [class.blink_me]="servicesOffTime>0" pTooltip="Control de citas" tooltipPosition="bottom" aria-label="Control de citas">
        <i class="pi pi-user"></i>
        <span class="bullet" *ngIf="servicesOffTime>0">{{servicesOffTime}}</span>
    </button>
    <button type="button" class="topbar-iconbtn" (click)="showChats()" [class.blink_me]="chatsNotReaded>0" pTooltip="Chat" tooltipPosition="bottom" aria-label="Chat">
        <i class="pi pi-comment"></i>
        <span class="bullet" *ngIf="chatsNotReaded>0">{{chatsNotReaded}}</span>
    </button>
    <button type="button" class="topbar-iconbtn" (click)="showNotifications()" [class.blink_me]="notificationsCount>0" pTooltip="Notificaciones" tooltipPosition="bottom" aria-label="Notificaciones">
        <i class="pi pi-bell"></i>
        <span class="bullet" *ngIf="notificationsCount>0">{{notificationsCount}}</span>
    </button>
    <button type="button" class="topbar-iconbtn" (click)="showPhone()" [class.blink_me]="!isPhoneConnected" pTooltip="Teléfono" tooltipPosition="bottom" aria-label="Teléfono">
        <i class="pi pi-phone"></i>
    </button>

    <div class="vsep"></div>

    <button type="button" class="theme-toggle" role="switch" [attr.aria-checked]="isDarkMode" (click)="toggleDarkMode()"
        aria-label="Modo oscuro" [pTooltip]="isDarkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'" tooltipPosition="bottom">
        <span class="knob"><i class="pi" [class.pi-sun]="!isDarkMode" [class.pi-moon]="isDarkMode"></i></span>
    </button>

    <button type="button" class="user" (click)="menuUser.toggle($event)" aria-label="Menú de usuario">
        <span class="avatar">{{userInitials}}</span>
        <span class="meta">
            <span class="name">{{user.name}}</span>
            <span class="role">{{user.userName}}</span>
        </span>
    </button>
    <p-menu #menuUser [model]="userActions" [popup]="true"></p-menu>
</header>

<div class="page-head" *ngIf="title || actions?.length">
    <div>
        <h1 class="page-title">{{ title }}<span *ngIf="count != null" class="page-count">{{ count | number: '1.0-0' }}</span></h1>
        <p *ngIf="subtitle" class="page-subtitle">{{ subtitle }}</p>
    </div>
    <div class="page-actions" *ngIf="actions?.length">
        <ng-container *ngFor="let action of actions">
            <button *ngIf="topbarService.getMenuItems(action) === undefined" type="button" class="page-btn"
                [class.primary]="isPrimaryAction(action)" (click)="topbarService.doAction(action)">
                <i [ngClass]="action.icon"></i>{{ action.label }}
            </button>
            <ng-container *ngIf="topbarService.getMenuItems(action)?.length > 0">
                <button type="button" class="page-btn icon" [class.primary]="isPrimaryAction(action)" (click)="menu.toggle($event)"
                    [pTooltip]="action.label" tooltipPosition="bottom" [attr.aria-label]="action.label">
                    <i [ngClass]="action.icon"></i>
                </button>
                <p-menu #menu [popup]="true" [model]="topbarService.getMenuItems(action)" appendTo="body"></p-menu>
            </ng-container>
        </ng-container>
    </div>
</div>

<p-dialog header="Modificar contraseña" [modal]="true" [(visible)]="visibleChangePass" [style]="{ width: '300px' }">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="password" class="p-col-4">Cambiar contraseña</label>
            <input pPassword type="password" id="password" class="flex-auto" autocomplete="off" [(ngModel)]="password" aria-label="Constraseña" />
        </div>
    </div>
    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Cerrar" icon="pi pi-times" styleClass="p-button-secondary" (click)="visibleChangePass = false"></p-button>
        <p-button label="Guardar" icon="pi pi-save"  (click)="saveChangePassword(password)"></p-button>
    </div>
</p-dialog>